import { tool_pairing_draft, tool_pairing_draft_dto } from '@Api';
import { Draft } from '@Models';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { DraftTeamMapper } from './DraftTeamMapper';

@injectable()
export class DraftMapper {
  @inject(TYPES.Mapper.DraftTeamMapper)
  private _draftTeamMapper!: DraftTeamMapper;

  public map(item: tool_pairing_draft): Draft {
    return {
      id: item.id,
      versionId: item.version_id,
      size: item.size,
      myTeam: this._draftTeamMapper.map(item.myTeam),
      opponentTeam:
        item.opponentTeam != null
          ? this._draftTeamMapper.map(item.opponentTeam)
          : null,
      maps: [],
    } satisfies Draft as Draft;
  }

  public toDto(item: Draft): tool_pairing_draft_dto {
    return {
      id: item.id,
      version_id: item.versionId,
      size: item.size,
      draft_maps_attributes: item.maps.map((map) => ({
        map_id: map.id,
      })),
    };
  }
}
